module.exports = __webpack_public_path__ + "img/wechat_white.4338d7fb.svg";